import { Icon } from '~/components';

export const IDENTIFIER_TYPES = {
  SODATONE: 'sodatone',
  OPUS: 'opus',
  ARTIST_PACK: 'artist_packs',
  SPOTIFY: 'spotify',
  INSTAGRAM: 'instagram',
  TIKTOK: 'tiktok',
  YOUTUBE: 'youtube',
};

export const DATA_TOOLS_ORDER = ['Opus', 'Sodatone', 'Artist Pack'];
export const SOCIALS_ORDER = ['spotify', 'youtube', 'tiktok', 'instagram'];
export const TRACK_SOCIALS_ORDER = ['spotify', 'apple', 'amazon', 'youtube'];

export const ERROR_FORM_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSefQ1_QjxKfrYjKxX0fDwgOr8iwGy8ZH0wIAO6Gz6HlU0YvJw/viewform';

export const BREADCRUMBS_PROPS = {
  ROOT: {
    className: 'flex items-center justify-start self-stretch text-body-xs',
    separator: (
      <Icon type="chevron-right" size="md" role="presentation" aria-hidden />
    ),
  },
  ITEM_LINK: {
    className: 'font-semibold underline transition text-hover hover:text-white',
  },
};
